import { __decorate, __metadata } from "tslib";
import { LengthUnit, Vector3 } from '../../utils';
import { NumberType, SerializableMember, SerializableObject } from '../decorators';
import { Relative2DPosition } from './Relative2DPosition';
/**
 * Relative 3D Position relative to another object. This indicates the translation
 * relative to another reference object.
 */
let Relative3DPosition = class Relative3DPosition extends Relative2DPosition {
  constructor(referenceObject, x, y, z, unit = LengthUnit.METER) {
    super(referenceObject, x, y, unit);
    this.referenceValue.z = z ? z : 0;
  }
  get z() {
    if (!this.referenceValue) {
      return undefined;
    }
    return this.referenceValue.z;
  }
  set z(value) {
    if (!this.referenceValue) {
      return;
    }
    this.referenceValue.z = value;
  }
  fromVector(vector, unit) {
    var _a, _b;
    if (unit) {
      this.x = unit.convert(vector.x, this.unit);
      this.y = unit.convert(vector.y, this.unit);
      this.z = unit.convert((_a = vector.z) !== null && _a !== void 0 ? _a : 0, this.unit);
    } else {
      this.x = vector.x;
      this.y = vector.y;
      this.z = (_b = vector.z) !== null && _b !== void 0 ? _b : 0;
    }
    return this;
  }
  toVector3(unit) {
    if (unit) {
      return new Vector3(this.unit.convert(this.x, unit), this.unit.convert(this.y, unit), this.unit.convert(this.z, unit));
    } else {
      return new Vector3(this.x, this.y, this.z);
    }
  }
  /**
   * Clone the position
   * @returns {Absolute3DPosition} Cloned position
   */
  clone() {
    const position = super.clone();
    position.x = this.x;
    position.y = this.y;
    position.z = this.z;
    return position;
  }
};
__decorate([SerializableMember({
  numberType: NumberType.DECIMAL
}), __metadata("design:type", Number), __metadata("design:paramtypes", [Number])], Relative3DPosition.prototype, "z", null);
Relative3DPosition = __decorate([SerializableObject(), __metadata("design:paramtypes", [Object, Number, Number, Number, LengthUnit])], Relative3DPosition);
export { Relative3DPosition };